import { Route, Routes } from "react-router-dom";
import Products from "./Products";
import ShopifyProductPage from "./ShopifyProductPage";

const ProductsRoute = () => {
  return (
    <Routes>
      <Route index element={<Products />} />
      <Route path="shopify" element={<ShopifyProductPage />} />
    </Routes>
  );
};

export default ProductsRoute;
